import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, X } from "lucide-react";

export default function GDPRBanner() {
  const nav = useNavigate();
  const [consent, setConsent] = useState(() => localStorage.getItem("pigeon-cookie-consent"));

  if (consent) return null;

  const accept = () => {
    localStorage.setItem("pigeon-cookie-consent", "accepted");
    setConsent("accepted");
  };

  const dismiss = () => {
    localStorage.setItem("pigeon-cookie-consent", "dismissed");
    setConsent("dismissed");
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6 pointer-events-none" data-testid="gdpr-banner">
      <div className="max-w-3xl mx-auto bg-slate-950 text-white rounded-2xl shadow-2xl border border-slate-800 p-5 md:p-6 pointer-events-auto">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-lime-500/10 border border-lime-500/30 rounded-xl flex items-center justify-center shrink-0">
            <Shield className="w-5 h-5 text-lime-400" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-bold mb-1 tracking-tight">Privacy & Data Protection</h4>
            <p className="text-xs text-slate-400 leading-relaxed">
              Pigeon Supply uses only essential cookies to function. No tracking, no ads. Your data is stored within the EU and processed in compliance with GDPR.{" "}
              <button
                onClick={() => { accept(); nav("/gdpr"); }}
                className="text-lime-400 underline hover:text-lime-300 font-medium"
                data-testid="gdpr-banner-policy-link"
              >
                Read our full Privacy & GDPR Policy
              </button>
            </p>
          </div>
          <button
            onClick={dismiss}
            className="p-1.5 text-slate-500 hover:text-white transition-colors shrink-0"
            data-testid="gdpr-banner-dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex items-center gap-3 mt-4 ml-14">
          <button
            data-testid="gdpr-banner-accept"
            onClick={accept}
            className="px-6 py-2.5 bg-lime-500 hover:bg-lime-400 text-slate-950 rounded-xl text-xs font-black uppercase tracking-wider transition-colors"
          >
            Accept & Continue
          </button>
          <button
            data-testid="gdpr-banner-settings"
            onClick={() => { accept(); nav("/gdpr"); }}
            className="px-4 py-2.5 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-xl text-xs font-bold border border-slate-700 transition-colors"
          >
            Privacy Settings
          </button>
        </div>
      </div>
    </div>
  );
}
